import s from '@pagestyles/Blog.module.scss'
import formStyles from '@commonStyles/Forms.module.scss'
import cn from 'classnames'
import { Button, LoadingDots } from '@corratech/pylot-ui/index'
import { useTranslation } from 'next-i18next'
import { useForm } from 'react-hook-form'
import { FC, useState } from 'react'
import { useRouter } from 'next/router'
import cs from '../common/Searchbar/Searchbar.module.scss'
import { Search } from '@components/icons'

interface SearchFormInput {
    searchQuery: string
}

const SearchPost: FC = () => {
    const { t } = useTranslation(['blog'])
    const route = useRouter()
    const searchURL = '/blog/search/'
    const {
        register: searchRegister,
        handleSubmit: handleSearchFormSubmit,
        reset: searchFormReset,
        formState: { errors: errorsComment }
    } = useForm<SearchFormInput>({ mode: 'onSubmit' })
    const [isLoading, setIsLoading] = useState(false)

    const onSubmitSearchForm = (inputs: SearchFormInput) => {
        setIsLoading(true)
        const url = searchURL + inputs.searchQuery
        route.push(url)
        searchFormReset()
        setIsLoading(false)
    }

    return (
        <div className={s['commentsform']}>
            <div className={s['commentsinput']}>
                <section className={formStyles.root}>
                    <form
                        key="searchForm"
                        onSubmit={handleSearchFormSubmit(onSubmitSearchForm)}
                    >
                        <h2>{t('Search Post')}</h2>
                        <div className="global-container">
                            <div className="searchPost">
                                <div key="searchQuery">
                                    <input
                                        id="searchQuery"
                                        type="text"
                                        placeholder={t('Search Blog')}
                                        {...searchRegister('searchQuery', {
                                            required: 'Enter the search text'
                                        })}
                                        className={cn('form-input', {
                                            'border-alert-danger':
                                                errorsComment.searchQuery
                                        })}
                                    />
                                    {errorsComment.searchQuery && (
                                        <span className="error">
                                            {t(
                                                `${errorsComment.searchQuery.message}`
                                            )}
                                        </span>
                                    )}
                                </div>
                                <div className="searchPosticon">
                                    <div className={cs['icon-container']}>
                                        <Button
                                            className={cs['search-icon']}
                                            variant="link"
                                            type="submit"
                                            disabled={isLoading}
                                        >
                                            <Search />
                                            {isLoading && <LoadingDots />}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </div>
    )
}

export default SearchPost
